import { memo } from 'react';
import { PlayerProfile } from './PlayerProfile';

export const PlayerLink = memo(({ uuid, name, showUuid = true, showAvatar = true }: { uuid: string, name?: string, showUuid?: boolean, showAvatar?: boolean }) => {
  return <PlayerProfile uuid={uuid} name={name} showUuid={showUuid} showAvatar={showAvatar} />;
});
